// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1L0qh","name":"styles_name__14y5x","phone":"styles_phone__-RwKy"};